<template>
  <div>
    <ul class="flex flex-wrap">
      <li class="flex items-center" v-for="(item, index) in routeClean" :key="item">
        <span
          class="text-lg font-normal uppercase leading-[1.2] tracking-[0.08em] text-ng70 transition duration-200 ease-out"
          >{{ $t(item).replace(/-/g, " ") }}</span
        >
        <span class="mx-2 tracking-[0em] text-ng70" v-if="index < routeClean.length - 1">|</span>
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import { generateBreadCrumb } from "@/utilities/breadcrumb";

const route = useRoute();

const routeClean = generateBreadCrumb(route);
</script>
<style lang="scss" scoped></style>
